export const roles = [
  "Frontend Developer.",
  "UI/UX Designer.",
  "Software Engineer.",
  "music enjoyer."
];

export const featuredProjects = [
  {
    id: 1,
    title: "West Coast Adult Soccer League",
    summary: "Designed and launched a full website for an 800+ player South OC soccer league — simple enough for schedule-checkers, smooth enough for first-time registrants.",
    types: ["Web Design", "Product Design"],
    media: "/images/wcasl/video.mp4",
    mediaType: "video",
    date: "Apr 2025 – Present",
    caseStudy: "/case-study/wcasl",
    links: {}
  },
  {
    id: 2,
    title: "PlasticBeach",
    summary: "Redesigned the site and recycling materials for a SoCal nonprofit cutting soft-plastic waste across 40+ retail and distribution partners.",
    types: ["Product Design", "UI/UX Design", "Web Redesign"],
    media: "/images/plasticbeach/video.mp4",
    mediaType: "video",
    date: "Apr 2025 - Jul 2025",
    caseStudy: "/case-study/plastic-beach",
    links: {
      final: "https://drive.google.com/file/d/1_jWW9Q3IAvawfwOCGiCDSiwZu14qLN4H/view?usp=sharing",
      slides: "https://docs.google.com/presentation/d/1eZOh0YGScuLrV9li4Mf-52dDeLcBS564lIW7Wg6i3wU/edit?usp=sharing"
    }
  },
  {
    id: 3,
    title: "Coming Soon",
    summary: "More projects on the way...",
    types: ["TBA"],
    media: "",
    mediaType: null,
    date: "2025",
    links: {}
  }
];
